// mixin for the half n half customize page

import { mapGetters, mapActions, mapMutations } from 'vuex'
import image from '../products/image'
import slug from 'slug'

export default {
  mixins: [image],
  data () {
    return {
      pizzaSelectionIds: [null, null],
      selectedSize: false,
      selectedBase: false
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$platform === 'pos') {
        if (this.parentProduct.product_type === 'halfNHalf') {
          this.pizzaSelectionIds = this.parentProduct.products.map(product => product ? product.id : null)
          if (this.parentProduct.selectedBase) {
            this.selectedBase = this.parentProduct.selectedBase.id
          }
        } else {
          this.pizzaSelectionIds = this.activeProduct.products.map(product => product ? product.id : null)
        }
      } else if (this.activeProduct.products) {
        this.pizzaSelectionIds = this.activeProduct.products.map(product => product ? product.id : null) // assign the selection
      }

      if (this.currentItem.product_type === 'deal') {
        this.setCurrentItem({ sizes: this.currentItem.sizes })
      } else {
        if (this.$platform !== 'pos') {
          this.setCurrentItem({ sizes: this.sizes })
        }
      }
      if (this.activeProduct.selectedSize) {
        this.selectedSize = this.activeProduct.selectedSize.size
      } else {
        this.selectedSize = this.sizes.length ? this.sizes[0].size : false
        if (this.selectedSize) {
          this.setHnhSize({ size: this.selectedSize, sizes: this.sizes }) // set the first size
        }
      }
      if (this.activeProduct.id === -1) {
        if (this.activeProduct.selectedBase) {
          this.selectedBase = this.activeProduct.selectedBase.id
        } else {
          this.selectedBase = this.availableBases.length ? this.availableBases[0].id : false
          if (this.selectedBase) {
            this.setBase(this.availableBases.filter(base => base.id === this.selectedBase)[0]) // set the first base
          }
        }
      }
    }, 10)
  },
  computed: {
    ...mapGetters([
      'configItemPrice',
      'products',
      'currentItem',
      'activeChild',
      'bases',
      'activeProduct',
      'parentProduct',
      'currentStore'
    ]),
    sizes () {
      if (this.pizzaOptions.length && this.pizzaOptions[0].items.length && this.pizzaOptions[0].items[0]) {
        return this.pizzaOptions[0].items.sort((a, b) => {
          return b.sizes.length - a.sizes.length
        })[0].sizes.filter(size => size.size !== 'small')
      }

      return []
    },
    pizzaOptions () {
      const products = JSON.parse(JSON.stringify(this.products))
      const selectedSize = this.currentItem.selectedSize ? this.currentItem.selectedSize.size : null
      return this.activeProduct.items.map(item => {
        return Object.values(products).filter(group => group.product_type_name === 'pizza')[0]
      })
        .filter(item => (item && item.items && item.items.length)).map(item => {
          if (selectedSize) {
            item.items = item.items.filter(item => item.sizes.map(size => size.size).includes(selectedSize)).filter(item => !item.tags.includes('vegan & gluten free'))
          }
          item.items = item.items.map(item => {
            const product = Object.assign(item, { showSize: false, showBase: false })// do not modify the menu
            if (product.sizes && Array.isArray(product.sizes)) { // set the size to child products the same as the deal
              product.selectedSize = false
              if (this.currentItem.selectedSize) {
                const size = product.sizes.filter(size => size.size === this.currentItem.selectedSize.size)[0]
                if (size) {
                  product.selectedSize = product.sizes.filter(size => size.size === this.currentItem.selectedSize.size)[0]
                }
              }
            }
            return product
          })
          return item
        })// only the valid options
    },
    pizzaSelection () {
      if (this.pizzaOptions.length) {
        return this.pizzaSelectionIds.map((id, idx)=> {
          return this.pizzaOptions[idx].items.filter(item => item.id === id)[0]
        })
      }
      return []
    },
    showSize () {
      return this.activeProduct.showSize !== undefined ? this.activeProduct.showSize : true
    },
    disabledSave () {
      return this.pizzaSelectionIds.filter(item => item === null).length !== 0
    },
    parentDescription () {
      if (this.parentProduct) {
        if (this.parentProduct.product_type === 'deal') {
          return this.parentProduct.name + ' ' + this.parentProduct.selectedSize.size
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions(['setSize', 'setBase', 'setCurrentItem']),
    ...mapMutations(['setCustomizedActiveChild', 'initCurrentItemProducts']),
    resetSelectedProduct () {
      // We need to empty out the selected product on hnh size change if the selected product (child) is not available in that size.
      // We simply empty it in pizzaSelectionIds.
      const selectedSize = this.currentItem ? (this.currentItem.selectedSize ? this.currentItem.selectedSize.size : null ) : null
      if (this.pizzaSelectionIds.length && selectedSize) {
        this.pizzaSelectionIds = this.pizzaSelectionIds.map((id, index) => {
          if (!id) {
            return null
          }
          if (this.pizzaOptions[index].items.length) {
            const itemFound = this.pizzaOptions[index].items.find(item => item.id === id)
            if (itemFound) {
              if (itemFound.sizes.map(size => size.size).includes(selectedSize)) {
                return id
              }
              this.setCurrentItem({ idx: this.activeChild.concat([index]), product:  null })
              return null
            }
          }
          this.setCurrentItem({ idx: this.activeChild.concat([index]), product:  null })
          return null
        })
      }
    },
    setHnhSize (data) {
      this.setSize(data)
      this.resetSelectedProduct()
      if (this.$platform === 'app') {
        setTimeout(() => {
          const selectedBase = this.availableBases.find(base => base.id === this.selectedBase)
          if (!selectedBase) {
            if (this.availableBases.length) {
              this.selectedBase = this.availableBases[0].id
              this.setBase(this.availableBases[0])
            }
          }
        }, 0)
      } else {
        const selectedBase = this.availableBases.find(base => base.id === this.selectedBase)
        if (!selectedBase) {
          if (this.availableBases.length) {
            this.selectedBase = this.availableBases[0].id
            this.setBase(this.availableBases[0])
          }
        }
      }
      if (this.$platform === 'app') {
        this.renderBaseControl = false
        setTimeout(() => {
          this.renderBaseControl = true
        }, 0)
      }
    },
    getBasePrice (base) {
      const size = base.sizes.filter(size => size.size === this.selectedSize)[0]
      if (size) {
        return parseFloat(size.price) !== 0 ? ( '+&pound;' + size.price) : ''
      }
      return ''
    },
    pizzaItemSelected (index) {
      const product = this.pizzaOptions[index].items.filter(item => item.id === this.pizzaSelectionIds[index])[0]
      const idx = this.activeChild.concat([index])
      this.setCurrentItem({ idx, product: product ? JSON.parse(JSON.stringify(product)) : null }) // reassign a product
    },
    save (e = false) { // emit the event that the pizza has been customized
      this.$emit('product:save', e)
    }
  }
}
